import floors from '@/store/locations/floors';
import rooms from '@/store/locations/rooms';
import zones from '@/store/locations/zones';
import deviceAreas from '@/store/locations/deviceAreas';
import { Dispatch } from 'vuex';

export default {
	namespaced: true,
	modules: {
		floors,
		rooms,
		zones,
		deviceAreas,
	},
	actions: {
		async fetchAllLocations({ dispatch }: { dispatch: Dispatch }): Promise<void> {
			await Promise.all([
				dispatch('floors/fetchFloors'),
				dispatch('rooms/fetchRooms'),
				dispatch('zones/fetchZones'),
				dispatch('deviceAreas/fetchDeviceAreas'),
			]);
		},

		cleanAllLocations({ dispatch }: { dispatch: Dispatch }): void {
			dispatch('floors/cleanAllFloor');
			dispatch('rooms/cleanAllRoom');
			dispatch('zones/cleanAllZone');
			dispatch('deviceAreas/cleanDeviceAreas');
		},
	},
};
